import React from 'react'
import {Button, Checkbox} from 'antd'
import styles from './UploadControl.module.scss'
import { humanFileSize } from '../helpers/helpers'
import { useComponentLocale } from '../hooks/useComponentLocale'

function UploadFooterButtons({ uploadRequest, uploadedFilesList, fileList, handleClearAll, filesSize, handleUpload }) {
	const getLocale = useComponentLocale()
	const startUploadLocale = getLocale({ component: 'common_buttons', section: 'start_upload' })
	const clearLocale = getLocale({ component: 'common_buttons', section: 'clear' })
	const newUploadLocale = getLocale({ component: 'common_buttons', section: 'new_upload' })

	return (
		<>
			{!uploadRequest && !uploadedFilesList.length ? (
				<div className={styles.actionBtns}>
					{fileList.length ? (
						<div className={styles.clearBtn}>
							<Button
								danger
								onClick={handleClearAll}
								className={styles.uploadBtn}
								loading={!!uploadRequest}
							>
								{clearLocale}
							</Button>
							<span className={styles.sizeInfoSpan}>Total size: {humanFileSize(filesSize)}</span>
							{
								/*
								<Checkbox>
									Run analysis after upload
								</Checkbox>
								 */
							}
							<Button
								type='primary'
								onClick={handleUpload}
								disabled={fileList.length === 0}
								className={styles.uploadBtn}
								loading={!!uploadRequest}
							>
								{startUploadLocale}
							</Button>
						</div>
					) : null}
				</div>
			) : null}

			{!uploadRequest && uploadedFilesList.length ? (
				<div className={styles.actionBtns}>


					<Button type='primary' onClick={handleClearAll} className={styles.uploadBtn}>
						{newUploadLocale}
					</Button>
				</div>
			) : null}
		</>
	)
}

export default UploadFooterButtons
